<template>
    <div :data-uuid="settings.uuid" :style="textStyle" class="widget-text">
        <EditorBuilder
            v-if="isBuilderEditor()"
            :value="settings.general.text"
            @update="settings.general.text = $event"
        />
        <Editor v-else inline :value="settings.general.text" @input="settings.general.text = $event" />
    </div>
</template>

<script>
import { resolveMargin, resolvePadding, resolveStyle } from "../utils/style"
import EditorBuilder from "@components/Editor/builder/EditorBuilder.vue"
import Editor from "@components/Editor/Editor.vue"

export default {
    components: { Editor, EditorBuilder },
    props: {
        settings: {
            type: Object,
            default: () => {}
        }
    },
    name: "WidgetTextInline",
    computed: {
        textStyle() {
            return {
                minWidth: "50px",
                ...resolveStyle(
                    {
                        ...resolvePadding(this.settings.desktop.padding),
                        ...resolveMargin(this.settings.desktop.margin)
                    },
                    {
                        ...resolvePadding(this.settings.mobile.padding),
                        ...resolveMargin(this.settings.mobile.margin)
                    }
                )
            }
        }
    },
    methods: {
        isBuilderEditor() {
            return !!this?.$route?.query?.editor
        },
        getHtml() {
            return this.settings.general.text
                .replaceAll("&quot;", "'")
                .replaceAll('<html-component open="true" value="', "")
                .replaceAll('<html-component open="false" value="', "")
                .replaceAll('"></html-component>', "")
                .replaceAll("\n")
        }
    }
}
</script>
<style lang="sass">
.widget-text:not(.active)
    .ProseMirror-menubar
        display: none !important
</style>
